import React, { useState } from "react";
import { toast } from "react-toastify";
import {
  GetGoodCallPlanListApi,
  GoodCallPlanAssignApi,
  PlansOrderCreateApi,
  PlansVerifyPaymentApi,
  PlansEmailVerifyApi,
} from "../../services/Api";
import { useNavigate } from "react-router-dom";

function GoodCallPlanBuy() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [isVerified, setIsVerified] = useState(false);
  const [planOne, setPlanOne] = useState(null);
  const [planTwo, setPlanTwo] = useState(null);
  const [userId, setUserId] = useState();

  // Fetch the two plans after verification
  const fetchPlans = async () => {
    try {
      const response = await GetGoodCallPlanListApi();
      if (response.status === "success") {
        
        const [first] = response.data;
        setPlanOne(first);
        setPlanTwo(first);
      } else {
        toast.error(response?.message || "Failed to load plans");
      }
    } catch (err) {
      console.error(err);
      toast.error("Failed to load plans");
    }
  };

  // Handle email verification
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) {
      toast.error("Please enter an email address");
      return;
    }
    setLoading(true);
    const response = await PlansEmailVerifyApi(email);
    setLoading(false);

    if (response.status === "success") {
      toast.success(response.message);
      setIsVerified(true);
      setUserId(response.data.id);
      fetchPlans();
    } else if (response.status === "failed" || response.status === "failure") {
      toast.error(response.message);
      navigate("/login");
    } else {
      toast.error("Email validation failed");
    }
  };

  // Handle Razorpay purchase and plan assignment
  const handlePay = async (selectedPlanId, amount) => {
    const {
      name,
      email: userEmail,
      phoneNumber: contact,
    } = JSON.parse(localStorage.getItem("userData"));
    const razorpayKey = process.env.REACT_APP_RAZORPAY_KEY;
    const orderType = "GOOD_CALL_PLAN_SUBSCRIPTION";

    try {
      const { orderId } = await PlansOrderCreateApi({
        amount,
        orderType,
        userId,
      });

      const options = {
        key: razorpayKey,
        amount: amount * 100,
        currency: "INR",
        name: "Good People",
        description: `Talktime ₹${amount}`,
        image:
          "https://goodpeople.live/static/media/logo.160934d3c48e5910d916.png",
        order_id: orderId,
        handler: async (data) => {
          await PlansVerifyPaymentApi({
            paymentId: data.razorpay_payment_id,
            signature: data.razorpay_signature,
            orderId,
          });
          const res = await GoodCallPlanAssignApi({
            planId: selectedPlanId,
            amount: amount,
            userId:userId
          });
          if (res.status === "success") {
            toast.success(res.message);
            navigate("/", { replace: true });
          } else if (res.status === "failure" || res.status === "failed") {
            toast.error(res.message);
          } else {
            toast.error("Something went wrong!");
          }
        },
        prefill: { name, email: userEmail, contact },
        notes: { address: "GoodPeople Corporate Office" },
        theme: { color: "#8047E1" },
      };

      const rzp = new window.Razorpay(options);
      rzp.on("payment.failed", () => {
        toast.error("Payment failed. Please try again.");
      });
      rzp.open();
    } catch (err) {
      console.error(err);
      toast.error("Payment initialization failed. Please try again.");
    }
  };

  return (
    <div className="good-call-plan-buy-page">
      {/* Email Verification Form */}
      {!isVerified && (
        <div className="good-call-plan-buy-container">
          <h2 className="good-call-plan-buy-title">Email Verification</h2>
          <form className="good-call-plan-buy-form" onSubmit={handleSubmit}>
            <label
              htmlFor="good-call-plan-buy-email"
              className="good-call-plan-buy-label"
            >
              Email Address
            </label>
            <input
              id="good-call-plan-buy-email"
              type="email"
              className="good-call-plan-buy-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@example.com"
              required
            />
            <button
              type="submit"
              className="good-call-plan-buy-button"
              disabled={loading}
            >
              {loading ? "Verifying…" : "Verify Email"}
            </button>
          </form>
        </div>
      )}

      {/* Full‑Page Premium Plan Cards */}
      {isVerified && planOne && planTwo && (
        <div className="good-call-plan-buy-cards-section">
          <div className="good-call-plan-buy-cards-grid">
            {[planOne, planTwo].map((plan, idx) => (
              <div
                key={plan.id}
                className={`good-call-plan-buy-card good-call-plan-buy-card-${
                  idx + 1
                }`}
              >
                <div className="good-call-plan-buy-badge">
                  {idx === 0 ? "Popular" : "Best Value"}
                </div>
                <div className="good-call-plan-buy-card-content">
                  <h3 className="good-call-plan-buy-card-title">
                    {plan.planName}
                  </h3>
                  <p className="good-call-plan-buy-card-type">
                    Type:{" "}
                    {plan.planType
                      .split("_")
                      .map((w) => w[0] + w.slice(1).toLowerCase())
                      .join(" + ")}
                  </p>
                  <div className="flex items-baseline mb-6">
                    <span className="good-call-plan-buy-card-price">
                      ₹{plan.amount}
                    </span>
                    <span className="good-call-plan-buy-card-price-duration">
                      / {plan.validityInDays}d
                    </span>
                  </div>
                  <ul className="good-call-plan-buy-card-features">
                    {plan.videoCall && <li>Video Calls Included</li>}
                    {plan.voiceCall && <li>Voice Calls Included</li>}
                    <li>{plan.validityInDays}-day Validity</li>
                  </ul>
                  <button
                    onClick={() => handlePay(plan.id, 1)}
                    className="good-call-plan-buy-card-button"
                  >
                    Buy Now
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

export default GoodCallPlanBuy;
